type BuildInfo = {
  buildNo: string
  buildTime?: string
}

export const buildInfo: BuildInfo = {
  buildNo: '7_5',
  buildTime: '2026-10-19T12:00:19.582Z',
}
